import React, { ReactNode } from 'react'
import { css } from '@emotion/css'

interface HelpTextProps {
  children: ReactNode
}

export function HelpText({ children }: HelpTextProps) {
  return (
    <p
      className={css`
        margin: 0;
        max-width: 180px;
        overflow-wrap: normal;
        white-space: normal;
      `}
    >
      {children}
    </p>
  )
}
